// test
export const increment = ({ commit }) => {
  commit('INCREMENT')
}
export const decrement = ({ commit }) => {
  commit('DECREMENT')
}
